import { handleActions } from 'redux-actions';
import {
  trackerSettingsForAppFetchInitialized,
  trackerSettingsForAppFetchSucceeded,
  trackerSettingsForAppUpdateSucceeded,
  trackerSettingsForAppDeleteSucceeded,
  TrackerSettingsResponse,
} from '../TrackerSettings';

export interface TrackerSettingsState {
  isLoading: boolean
  settings?: TrackerSettingsResponse
  failed: boolean
}

const initialState: TrackerSettingsState = {
  isLoading: true,
  failed: false,
  settings: {
    id: '',
    type: '',
    attributes: {},
  },
};

// @ts-ignore
export default handleActions<TrackerSettingsState, any>({
  [trackerSettingsForAppFetchInitialized as any]: (
    state: TrackerSettingsState,
  ) => ({
    ...state,
    isLoading: true,
    settings: initialState.settings,
  }),
  [trackerSettingsForAppFetchSucceeded as any]: (
    state: TrackerSettingsState,
    { payload }: { payload: TrackerSettingsResponse },
  ) => ({
    ...state,
    isLoading: false,
    settings: {
      ...state.settings,
      ...payload,
    },
  }),
  [trackerSettingsForAppUpdateSucceeded as any]: (
    state: TrackerSettingsState,
    { payload }: { payload: any },
  ) => ({
    ...state,
    settings: {
      ...state.settings,
      attributes: {
        ...state.settings?.attributes,
        ...payload,
      },
    },
  }),
  [trackerSettingsForAppDeleteSucceeded as any]: (
    state: TrackerSettingsState,
    { payload }: { payload: string },
  ) => ({
    ...state,
    settings: {
      ...state.settings,
      attributes: {
        ...state.settings?.attributes,
        [payload]: undefined,
      },
    },
  } as TrackerSettingsState),
}, initialState);
